export default {"src":"/_next/static/media/4-banner.0c2b2536.gif","height":450,"width":800,"blurWidth":0,"blurHeight":0};